import { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid";
import { useFacility } from "../../utils/hooks/useFacility";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../utils/auth/msalConfig";
import "../Order/OrderNow.css";

const OrderNow = () => {

    const { facility, loadFacility } = useFacility();
    const { instance } = useMsal()

    useEffect(() => {
        loadFacility()
    }, []);

    const orderNowData = facility?.[0];

    //msal login
    const handleLogin = async () => {
        if (!instance) {
            console.error("MSAL instance undefined");
            return;
        }

        if (!instance.initialized) {
            try {
                await instance.initialize();
            } catch (error) {
                return;
            }
        }

        try {
            //redirect AFTER login
            sessionStorage.setItem("postLoginRedirect", "/productCatalog");
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error(error);
        }
    };


    //external links
    const openLink = (url) => {
        if (!url) return;
        window.open(url, "_self");
    };
    
    //check html tag or plain text
    const hasHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);
    
    //converts into React style obj
    const extractStyle = (html) => {
        if (!html) return {};

        const match = html.match(/style=['"]([^'"]*)['"]/i);
        if (!match) return {};

        const styleString = match[1];
        const styles = {};

        styleString.split(";").forEach((rule) => {
            const [key, value] = rule.split(":");
            if (!key || !value) return;

            const k = key.trim().toLowerCase();
            const v = value.trim();

            if (k === "background" || k === "background-color")
                styles.backgroundColor = v;

            if (k === "color") styles.color = v;
        });

        return styles;
    };

    //raw html 
    const renderContent = (value) => {
        if (!value) return null;

        if (hasHTML(value)) {
            return <span dangerouslySetInnerHTML={{ __html: value }} />;
        }

        return value;
    };

    //buttons 
    const loginText = orderNowData?.orderNowLoginButtonText;
    const btn2Text = orderNowData?.orderNowNewUserHaveCustomerNumButtonText;
    const btn3Text = orderNowData?.orderNowNoCustomerNumNewUserButtonText;

    const loginStyle = extractStyle(loginText);
    const btn2Style = extractStyle(btn2Text);
    const btn3Style = extractStyle(btn3Text);
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#f7f9fc",
                px: 1,
                p: { xs: 3 }
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    maxWidth: 900,
                    width: "100%",
                    borderRadius: 4,
                    p: { xs: 3, md: 5 }
                }}
            >
                <Grid sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                    <Box src="/images/cohere_logo.gif" component="img" sx={{ maxWidth: 260,scale:1.1 }} />
                </Grid>

                <Typography variant="h5" sx={{ textAlign: "center", fontWeight: 600, mb: 2 }}>
                    {renderContent(orderNowData?.orderNowTitle)}
                </Typography>

                {orderNowData?.orderNowInstructions && (
                    <Typography
                        variant="body1"
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            mb: 2,
                            maxWidth: 600,
                            mx: "auto",
                            wordBreak: "break-word",
                            maxHeight: "120px",
                            overflow: "auto",
                        }}
                    >
                        {renderContent(orderNowData.orderNowInstructions)}
                    </Typography>
                 )} 

                <Stack spacing={3} mx="auto">
                    {/* LOGIN BUTTON */}
                    <button
                        className="orderNowBtn"
                        style={loginStyle}
                        onClick={handleLogin}
                    >
                        {renderContent(loginText)}
                    </button>

                    {/* BUTTON 2 */}
                    <button
                        className="orderNowBtn"
                        style={btn2Style}
                        onClick={() =>
                            openLink(orderNowData?.orderNowNewUserHaveCustomerNumButtonHyperLink)
                        }
                    >
                        {renderContent(btn2Text)}
                    </button>

                    {/* BUTTON 3 */}
                    <button
                        className="orderNowBtn"
                        style={btn3Style}
                        onClick={() =>
                            openLink(orderNowData?.orderNowNoCustomerNumNewUserButtonHyperLink)
                        }
                    >
                        {renderContent(btn3Text)}
                    </button>
                </Stack>
            </Paper>
        </Box>
    );
};

export default OrderNow;
